<template>
  <v-tabs
    :value="value"
    background-color="transparent"
    :slider-size="3"
    class="rmr-tabs"
    v-bind="$attrs"
    v-on="listeners"
  >
    <v-tab
      v-for="tab in tabs"
      :key="tab.key"
      class="rmr-tabs__tab"
    >
      <v-icon v-if="tab.icon" left small>{{ tab.icon }}</v-icon>
      {{ tab.label }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: "RmrTabs",
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    tabs: {
      type: Array,
      required: true,
      // Each item: { key: String, label: String, icon?: String }
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        change: (val) => this.$emit("input", val),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.rmr-tabs {
  border-bottom: 2px solid $rmr-border-hover;

  ::v-deep .v-tabs-slider {
    color: $rmr-indigo !important;
    border-radius: 2px 2px 0 0;
  }
}

.rmr-tabs__tab {
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  letter-spacing: 0.2px !important;
  color: $rmr-text-subtle !important;
  min-width: 120px;

  &.v-tab--active {
    color: $rmr-indigo-dark !important;
  }
}
</style>
